import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import { getClasificaciones } from 'api/configuracion';

// eslint-disable-next-line react/prop-types
const Clasificaciones = ({ permission }) => (
  <PlainCRUD
    title="Clasificaciones"
    permission={permission}
    get={getClasificaciones}
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
    ]}
    readOnly
  />
);

export default Clasificaciones;
